import { ArrowLeftRight, ChartPie, Receipt, Wallet } from "lucide-react";

export const MONTH_RANGE = "month";
export const REPORTING_LEVEL = "reporting_level";
export const ZONE = "zoneIds";
export const BLOCK = "blockIds";
export const PROPERTY = "propertyIds";
export const FISCAL_YEAR = "fiscalYear";
export const DIST_STATUS = "distributionStatuses";
export const DIST_TYPE = "distributionTypes";
export const RECORD_TYPE = "recordType";
export const FROM_MONTH = "fromMonth";
export const TO_MONTH = "toMonth";
export const FROM_YEAR = "fromYear";
export const TO_YEAR = "toYear";
export const GL_FILTER_MODE = "glFilterMode";
export const GL_MASTER_IDS = "glMasterIds";

export const recordTypeOption = [
  {label: 'All', value: "all"},
  {label: 'Primary', value: "PRIMARY"},
  {label: 'Secondary', value: "SECONDARY"},
];

export const distStatusOption = [
  {label: 'Fully Allocated', value: "FULLY_ALLOCATED", className: "text-green-600"},
  {label: 'Pending', value: "PENDING", className: "text-amber-600"},
  {label: 'Reversed', value: "REVERSED", className: "text-red-600"},
  {label: 'Not Configured', value: "NOT_CONFIGURED", className: "text-indigo-600"},
];

export const distTypeOption = [
  {label: 'Real Time', value: "REAL_TIME"},
  {label: 'Monthly', value: "MONTHLY"},
  {label: 'Quarterly', value: "QUARTERLY"},
  {label: 'Yearly', value: "YEARLY"},
  {label: 'Adhoc', value: "ADHOC"},
]

export const summaryCards = [
  {
    title: "Primary Posting",
    icon: Receipt,
    iconWrapper: "bg-primary",
    amtKey: "primaryExpense",
    children: [
      {
        label: 'DR',
        key: 'primaryDr'
      },
      {
        label: 'CR',
        key: 'primaryCr'
      }
    ],
    desc: "Original Posting",
    className: "bg-blue-50 border-1 border-blue-100"
  },
  {
    title: "Secondary Posting",
    icon: ArrowLeftRight,
    iconWrapper: "bg-purple-600",
    amtKey: "secondaryDebit",
    children: [
      {
        label: 'DR',
        key: 'secondaryDr'
      },
      {
        label: 'CR',
        key: 'secondaryCr'
      }
    ],
    desc: "Receiver debits",
    className: "bg-purple-50 border-1 border-purple-100"
  },
  {
    title: "Allocate Expense",
    icon: ChartPie,
    iconWrapper: "bg-green-600",
    amtKey: "allocatedExpense",
    desc: "Pushed to cost objects",
    className: "bg-green-50 border-1 border-green-100"
  },
  {
    title: "Unallocated",
    icon: Wallet,
    iconWrapper: "bg-orange-600",
    amtKey: "unallocated",
    desc: "Pending distribution",
    className: "bg-orange-50 border-1 border-orange-100"
  }
]